import { render } from "./Apropos.vue?vue&type=template&id=195fd69a"
import script from "./Apropos.vue?vue&type=script&lang=js"
export * from "./Apropos.vue?vue&type=script&lang=js"

import "./Apropos.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__